import { render, staticRenderFns } from "./DiscountTabLinks.vue?vue&type=template&id=14dd368a&"
import script from "./DiscountTabLinks.vue?vue&type=script&lang=js&"
export * from "./DiscountTabLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports